// extracted by mini-css-extract-plugin
export var label = "_kt-2";
export var slideContainer = "_kt-0";
export var slider = "_kt-1";